<template>
  <div class="checklist-inspection-table-wrapper">
    <v-row class="row ps-4 mb-4 top-section-class mt-5">
      <v-col class="search-checklist">
        <SearchByModal
          v-if="true"
          @onSearch="handleSearchEvent"
          label="Filters"
          :length="localChipText.length"
          ghostText="Search"
          type="button"
          btnText="Add Checkpoint"
          :valueSearch="localFilterText"
          @onClick="handleClickEvent"
          @removeFilter="handleRemoveFilterEvent"
          :levelCounter="effectiveLevelCounter"
          :counterSection="true"
          @filterTypes="handleFilterTypesEvent"
          :removeCounterLevelFilter="removeCounterLevelFilter"
          :filterLevels="selectedFilterLevels"
          :aiAction="{
            enabled: false,
            objectName: 'Inspection',
            theme: 'strong',
          }"
          :filterType="filterType"
          @clearSelection="handleClearSelectionEvent"
          @onCheckedItemsChanged="handleCheckedItemsChangedEvent"
        />
      </v-col>
    </v-row>
    <SharedTableSkeleton v-if="loading" :column-count="1" column-template="1fr" />
    <NoRecordFound
      v-else-if="shouldShowNoRecordFound"
      :should-show-add-action="false"
      :title="'CheckPoints'"
      :message="'Checkpoints'"
      :btnTitle="'Inspection'"
      :subtitle="''"
      :description="''"
      @onAction="$emit('onClick', 'add')"
      class="no-record-found"
      :noBorder="true"
      :showActiveCounter="false"
      :showSpecificMessage="noRecordMessage"
      :showClearAction="shouldShowClearAction"
      :clearLabel="clearLabel"
      @onClear="handleClearSelectionEvent"
      :showAddWithAI="false"
    />
    <DxDataGrid
      v-if="!loading && !shouldShowNoRecordFound"
      id="ex-checkpoints-datagrid"
      :data-source="displayedInspectionData"
      :column-auto-width="true"
      :word-wrap-enabled="true"
      :show-row-lines="true"
      :show-column-lines="false"
      :show-borders="false"
      :filter-value="[]"
      :element-attr="{ class: 'ex-checkpoints-table-grid' }"
      :on-content-ready="() => {}"
      no-data-text=""
    >
      <DxRowDragging :allow-reordering="false" :on-reorder="() => {}" :show-drag-icons="true" />
      <DxColumn
        data-field="Checkpoints"
        caption="Checkpoints to be inspected"
        cell-template="checkpoints"
      />
      <template #checkpoints="{ data }">
        <AsACoachCheckpointInspectionCard
          :level="data.data.level"
          :criteria="data.data.criteria"
          :instructions="data.data.instructions"
          :showAllInstructionIcon="data.data.showAllInstructionIcon"
          :video="data.data.video"
          :inspectionStatus="data.data.inspectionStatus"
          :evaluationData="{
            isPassed: data.data.isPassed,
            isFailed: data.data.isFailed,
            isNotApplicable: data.data.isNotApplicable,
            first_name: data.data.first_name,
            last_name: data.data.last_name,
            updated_on: data.data.updated_on,
            updated_by: data.data.updated_by,
            avatar: data.data.avatar,
            failed_reason: data.data.failed_reason,
            not_applicable_reason: data.data.not_applicable_reason,
            reset_reason: data.data.reset_reason,
          }"
          @onPass="$emit('onPass', data.data)"
          @onFail="$emit('onFail', data.data)"
          @onNotApplicable="$emit('onNotApplicable', data.data)"
          @onClose="$emit('onClose', data.data)"
          @watchVideo="handleWatchVideo"
          @showAllInstructions="(eventData) => handleShowAllInstructions(eventData, data.data)"
        />
      </template>
    </DxDataGrid>
    <ExPagination
      v-if="!loading && shouldShowPagination"
      :pagination="effectivePagination"
      @onRequest="handlePaginationRequest"
    />

    <v-dialog
      v-model="showMicroLearningPlayer"
      max-width="680px"
      class="microlearning-dialog"
      @click:outside="closeMicroDialog"
    >
      <v-card class="microlearning-card">
        <v-card-title class="microlearning-title">
          <span class="title-text">Video</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeMicroDialog" class="close-btn close-btn-class">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="microlearning-content p-3">
          <div v-if="microlearningVideoUrl" class="microlearning-video-container">
            <video controls class="microlearning-video">
              <source :src="microlearningVideoUrl" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          <div
            v-else-if="microlearningIframe"
            v-html="microlearningIframe"
            class="microlearning-iframe-container"
          ></div>
          <div v-else class="no-content">
            <v-icon size="64" color="grey">mdi-video-off</v-icon>
            <p>No video content available</p>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Show All Instructions Dialog -->
    <v-dialog
      v-model="showAllInstructionsDialog"
      max-width="800px"
      class="show-all-instructions-dialog"
      @click:outside="closeShowAllInstructionsDialog"
    >
      <v-card class="show-all-instructions-card">
        <v-card-title class="show-all-instructions-title">
          <span class="title-text">Checkpoint Details</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeShowAllInstructionsDialog" class="close-btn close-btn-class">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="show-all-instructions-content p-3">
          <AsACoachCheckpointShowAllCard
            v-if="showAllInstructionsData"
            :level="showAllInstructionsData.level"
            :criteria="showAllInstructionsData.criteria"
            :instructions="showAllInstructionsData.instructions"
            :video_url="showAllInstructionsData.video"
            :isInspectionMode="isInspectionMode"
            :inspection_status="
              showAllInstructionsData.inspectionStatus === 'pending-evaluation'
                ? 'Not yet evaluated'
                : showAllInstructionsData.inspectionStatus === 'passed-evaluation'
                  ? 'Passed'
                  : showAllInstructionsData.inspectionStatus === 'failed-evaluation'
                    ? 'Failed'
                    : showAllInstructionsData.inspectionStatus === 'notapplicable-evaluation'
                      ? 'NA'
                      : showAllInstructionsData.inspectionStatus === 'reset-pending-evaluation'
                        ? 'Reset Pending Evaluation'
                        : ''
            "
            :failed_reason="showAllInstructionsData.evaluationData?.failed_reason || ''"
            :not_applicable_reason="
              showAllInstructionsData.evaluationData?.not_applicable_reason || ''
            "
            :obsolete_reason="showAllInstructionsData.evaluationData?.obsolete_reason || ''"
            :inspector_info="{
              first_name: showAllInstructionsData.evaluationData?.first_name || '',
              last_name: showAllInstructionsData.evaluationData?.last_name || '',
              updated_on: showAllInstructionsData.evaluationData?.updated_on || '',
              avatar: showAllInstructionsData.evaluationData?.avatar || '',
            }"
            @onPass="handleShowAllInstructionsPass"
            @onFail="handleShowAllInstructionsFail"
            @onNotApplicable="handleShowAllInstructionsNotApplicable"
            @onObsolete="handleShowAllInstructionsObsolete"
            @onClose="handleShowAllInstructionsClose"
            @watchVideo="handleWatchVideo"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import { ref, computed, nextTick, watch } from "vue";
import SearchByModal from "@components/SearchBar/SearchByModal.vue";
import NoRecordFound from "@components/NoRecordFound/NoRecordFound.vue";
import SharedTableSkeleton from "@components/SharedTableSkeleton/SharedTableSkeleton.vue";
import ExPagination from "@components/DataTable/ExPagination.vue";
import { DxDataGrid, DxColumn, DxRowDragging } from "devextreme-vue/data-grid";
import AsACoachCheckpointInspectionCard from "@components/AsACoachCheckpointInspectionCard/AsACoachCheckpointInspectionCard.vue";
import AsACoachCheckpointShowAllCard from "@components/AsACoachCheckpointShowAllCard/AsACoachCheckpointShowAllCard.vue";

import { isLevelSelected } from "@components/utils/normalizeBadgeLevel";
// Reactive data for video player
const showMicroLearningPlayer = ref(false);
const microlearningIframe = ref(null);
const microlearningVideoUrl = ref(null);

// Reactive data for show all instructions dialog
const showAllInstructionsDialog = ref(false);
const showAllInstructionsData = ref(null);
const showAllInstructionsCheckpointData = ref(null);

const selectedFilterLevels = ref([]);
const removeCounterLevelFilter = ref(false);

const props = defineProps({
  inspectionData: {
    type: Array,
    default: () => [],
  },
  filterText: {
    type: String,
    default: "",
  },
  showNoRecords: {
    type: Boolean,
    default: false,
  },
  showPagination: {
    type: Boolean,
    default: false,
  },
  /** MDP-560 — parent-fed fetch state; when true the shared skeleton replaces the empty state and grid. */
  loading: {
    type: Boolean,
    default: false,
  },
  pagination: {
    type: Object,
    default: () => ({
      total: 0,
      page: 1,
      perPage: 10,
    }),
  },
  chipText: {
    type: Array,
    default: () => [],
  },
  filterGroups: {
    type: Array,
    default: () => [],
  },
  filterType: {
    type: String,
    default: "Checkpoint",
  },
  statusOptions: {
    type: Array,
    default: () => [],
  },
  groupsItems: {
    type: Array,
    default: () => [],
  },
  isInspectionMode: {
    type: Boolean,
    default: true,
  },
  levelCounter: {
    type: Object,
    default: () => ({
      Apprentice: 0,
      Proficient: 0,
      Coach: 0,
      Architect: 0,
    }),
  },
});

const emit = defineEmits([
  "onSearch",
  "onClick",
  "removeFilter",
  "filterTypes",
  "onPaginationRequest",
  "clearSelection",
  "onCheckedItemsChanged",
  "onPass",
  "onFail",
  "onNotApplicable",
  "onClose",
]);

const localFilterText = ref(props.filterText ?? "");
const localChipText = ref(Array.isArray(props.chipText) ? [...props.chipText] : []);

watch(
  () => props.filterText,
  (next) => {
    localFilterText.value = next ?? "";
  }
);

watch(
  () => props.chipText,
  (next) => {
    localChipText.value = Array.isArray(next) ? [...next] : [];
  },
  { deep: true }
);

const localPagination = ref({
  total: props.pagination?.total ?? 0,
  page: props.pagination?.page ?? 1,
  perPage: props.pagination?.perPage ?? 10,
});

watch(
  () => props.pagination,
  (next) => {
    if (!next) return;
    localPagination.value = {
      total: next.total ?? 0,
      page: next.page ?? 1,
      perPage: next.perPage ?? 10,
    };
  },
  { deep: true, immediate: true }
);

const isServerSidePagination = computed(() => {
  if (!props.showPagination) return false;
  const total = Number(props.pagination?.total ?? 0);
  const perPage = Number(props.pagination?.perPage ?? 10);
  const dataLen = props.inspectionData?.length ?? 0;

  // Heuristic: if API says more rows exist than we currently have,
  // and the current data looks like a single page, assume server-side pagination.
  return total > dataLen && dataLen <= perPage;
});

const selectedStatusFilters = computed(() => {
  return (localChipText.value ?? [])
    .filter(Boolean)
    .map((s) => String(s).trim())
    .filter((s) => s.length > 0 && s !== "No Filter");
});

const hasActiveFiltersOrSearch = computed(() => {
  const hasSearch = (localFilterText.value ?? "").trim().length > 0;
  const hasLevelFilters = (selectedFilterLevels.value ?? []).filter(Boolean).length > 0;
  const hasStatusChips = (selectedStatusFilters.value ?? []).length > 0;
  return hasSearch || hasLevelFilters || hasStatusChips;
});

const shouldShowClearAction = computed(() => {
  // Only show "Clear" when the empty state is caused by search/filters.
  return hasActiveFiltersOrSearch.value;
});

const shouldShowNoRecordFound = computed(() => {
  // Parent-controlled "no data exists" state (e.g. empty responsibility).
  if (props.showNoRecords) return true;

  // "No results" state caused by filters/search.
  if (!hasActiveFiltersOrSearch.value) return false;

  // In server-side mode, the API/parent returns already-filtered data (may be empty).
  if (isServerSidePagination.value) {
    return (props.inspectionData?.length ?? 0) === 0;
  }

  // In client-side mode we can compute results locally.
  return (filteredInspectionData.value?.length ?? 0) === 0;
});

const noRecordMessage = computed(() => {
  if (props.showNoRecords) {
    return "No Checkpoints exist for this responsibility";
  }
  return "No Checkpoints found based on the current filters";
});

const baseFilteredInspectionData = computed(() => {
  // In server-side mode, the parent/API is expected to return already-filtered data.
  if (isServerSidePagination.value) return props.inspectionData ?? [];

  const rows = props.inspectionData ?? [];
  const q = (localFilterText.value ?? "").trim().toLowerCase();
  const statusFilters = selectedStatusFilters.value;

  return rows.filter((row) => {
    // Search text (criteria, instructions, level)
    if (q) {
      const haystack = [row?.criteria, row?.instructions, row?.level]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      if (!haystack.includes(q)) return false;
    }

    // Status chips (AND across selected chips)
    for (const chip of statusFilters) {
      switch (chip) {
        case "Not Yet Passed": {
          if (row?.isPassed === true) return false;
          break;
        }
        case "Only Failed": {
          if (!(row?.isFailed === true || String(row?.inspectionStatus ?? "").includes("failed")))
            return false;
          break;
        }
        case "Only Not Yet Evaluated": {
          if (!String(row?.inspectionStatus ?? "").includes("pending")) return false;
          break;
        }
        case "Only Reset": {
          if (!String(row?.inspectionStatus ?? "").includes("reset")) return false;
          break;
        }
        case "Only Not Applicable": {
          if (
            !(
              row?.isNotApplicable === true ||
              String(row?.inspectionStatus ?? "").includes("notapplicable")
            )
          )
            return false;
          break;
        }
        case "Only Passed": {
          if (!(row?.isPassed === true || String(row?.inspectionStatus ?? "").includes("passed")))
            return false;
          break;
        }
        default:
          // Unknown chip label: don't filter out anything.
          break;
      }
    }

    return true;
  });
});

const filteredInspectionData = computed(() => {
  if (isServerSidePagination.value) return baseFilteredInspectionData.value;

  const selectedLevels = (selectedFilterLevels.value ?? [])
    .filter(Boolean)
    .map((s) => String(s).trim().toLowerCase());

  if (selectedLevels.length === 0) return baseFilteredInspectionData.value;

  return baseFilteredInspectionData.value.filter((row) => {
    const level = String(row?.level ?? "").toLowerCase();
    return (
      isLevelSelected(selectedFilterLevels.value, row?.level) ||
      selectedLevels.some((lvl) => level.includes(lvl))
    );
  });
});

const effectiveLevelCounter = computed(() => {
  // In server-side mode we don't have all rows to compute counts accurately.
  if (isServerSidePagination.value) return props.levelCounter;

  const next = {
    Apprentice: 0,
    Proficient: 0,
    Coach: 0,
    Architect: 0,
  };

  const rows = baseFilteredInspectionData.value ?? [];
  for (const row of rows) {
    const level = String(row?.level ?? "").toLowerCase();
    if (level.includes("apprentice")) next.Apprentice += 1;
    else if (level.includes("professional") || level.includes("proficient")) next.Proficient += 1;
    else if (level.includes("coach")) next.Coach += 1;
    else if (level.includes("master") || level.includes("architect")) next.Architect += 1;
  }

  return next;
});

const effectivePagination = computed(() => {
  if (isServerSidePagination.value) return props.pagination;

  const total = filteredInspectionData.value.length;

  return {
    total,
    page: localPagination.value.page ?? 1,
    perPage: localPagination.value.perPage ?? 10,
  };
});

const shouldShowPagination = computed(() => {
  if (!props.showPagination) return false;

  const total = Number(effectivePagination.value?.total ?? 0);
  const perPage = Number(effectivePagination.value?.perPage ?? 10);

  // Show only when there's more than one page worth of rows.
  return total > perPage;
});

const displayedInspectionData = computed(() => {
  if (!props.showPagination) return filteredInspectionData.value;
  if (isServerSidePagination.value) return props.inspectionData;

  const page = Number(localPagination.value.page ?? 1);
  const perPage = Number(localPagination.value.perPage ?? 10);
  const start = Math.max(0, (page - 1) * perPage);
  const end = start + perPage;

  return filteredInspectionData.value.slice(start, end);
});

watch(
  () => [localFilterText.value, selectedFilterLevels.value, localChipText.value],
  () => {
    // When filters change in client-side mode, snap back to page 1.
    if (!isServerSidePagination.value) {
      localPagination.value = { ...localPagination.value, page: 1 };
    }
  },
  { deep: true }
);

watch(
  () => filteredInspectionData.value.length,
  (len) => {
    if (isServerSidePagination.value) return;
    const perPage = Number(localPagination.value.perPage ?? 10);
    const totalPages = Math.max(1, Math.ceil((len ?? 0) / perPage));
    const current = Number(localPagination.value.page ?? 1);
    if (current > totalPages) {
      localPagination.value = { ...localPagination.value, page: totalPages };
    }
  }
);

const clearLabel = computed(() => {
  const hasFilters = (selectedStatusFilters.value?.length ?? 0) > 0;
  const hasLevels = (selectedFilterLevels.value ?? []).filter(Boolean).length > 0;
  const hasSearch = (localFilterText.value ?? "").trim().length > 0;
  const hasAnyFilter = hasFilters || hasLevels;

  if (hasAnyFilter && hasSearch) {
    return "Clear";
  } else if (hasAnyFilter) {
    return "Clear Filter";
  } else if (hasSearch) {
    return "Clear Search";
  }

  return "Clear";
});

const handleSearchEvent = (event) => {
  localFilterText.value = event ?? "";
  emit("onSearch", event);
};

const handleClickEvent = (event) => {
  emit("onClick", event);
};

const handleRemoveFilterEvent = (event) => {
  const removed = String(event ?? "").trim();
  if (removed) {
    localChipText.value = (localChipText.value ?? []).filter((c) => c !== removed);
  }
  emit("removeFilter", event);
};

const handleFilterTypesEvent = (event) => {
  selectedFilterLevels.value = event;
  emit("filterTypes", event);
};

const handleClearSelectionEvent = (event) => {
  // If SearchBar emits a specific chip label to clear, remove only that chip.
  // Otherwise clear everything relevant (filters/search) based on current state.
  if (event) {
    const removed = String(event ?? "").trim();
    if (removed) {
      localChipText.value = (localChipText.value ?? []).filter((c) => c !== removed);
    }
  } else {
    const nextLabel = clearLabel.value;

    // Clear search only
    if (nextLabel === "Clear Search") {
      localFilterText.value = "";
      emit("onSearch", "");
    }

    // Clear filters only (chips + levels)
    if (nextLabel === "Clear Filter") {
      selectedFilterLevels.value = [];
      localChipText.value = [];
    }

    // Clear all (search + filters)
    if (nextLabel === "Clear") {
      selectedFilterLevels.value = [];
      localChipText.value = [];
      localFilterText.value = "";
      emit("onSearch", "");
    }
  }

  removeCounterLevelFilter.value = true;

  nextTick(() => {
    removeCounterLevelFilter.value = false;
  });

  emit("clearSelection", event);
};

const handleCheckedItemsChangedEvent = (event) => {
  // Mirror SearchByModal's display mapping so filtering works even when the parent
  // doesn't re-bind chipText (e.g. Storybook).
  const mapped = Array.isArray(event)
    ? event
        .map((item) => {
          if (item == null) return null;
          if (typeof item === "string") return item;
          if (typeof item === "object" && Object.prototype.hasOwnProperty.call(item, "value")) {
            return item.value;
          }
          return null;
        })
        .filter(Boolean)
    : [];
  localChipText.value = mapped;
  emit("onCheckedItemsChanged", event);
};

const handlePaginationRequest = (event) => {
  const nextPage = Number(event?.page ?? 1);
  if (!Number.isFinite(nextPage) || nextPage < 1) return;

  localPagination.value = {
    ...localPagination.value,
    page: nextPage,
  };

  emit("onPaginationRequest", event);
};

// Video player handlers
// Supports either:
// - raw iframe HTML string (legacy microlearning embeds)
// - direct video URL string (mp4)
const handleWatchVideo = (videoContent) => {
  const value = typeof videoContent === "string" ? videoContent.trim() : "";
  if (!value) return;

  const looksLikeHtml = value.startsWith("<") && value.includes("iframe");

  microlearningIframe.value = looksLikeHtml ? value : null;
  microlearningVideoUrl.value = looksLikeHtml ? null : value;
  showMicroLearningPlayer.value = true;
};

const closeMicroDialog = () => {
  showMicroLearningPlayer.value = false;
  microlearningIframe.value = null;
  microlearningVideoUrl.value = null;
};

const handleShowAllInstructions = (data, checkpointData) => {
  // checkpointData contains the full checkpoint info from the table row
  // data contains the display data from the card component
  showAllInstructionsData.value = data;
  showAllInstructionsCheckpointData.value = checkpointData || null;
  showAllInstructionsDialog.value = true;
};

const closeShowAllInstructionsDialog = () => {
  showAllInstructionsDialog.value = false;
  showAllInstructionsData.value = null;
  showAllInstructionsCheckpointData.value = null;
};

const handleShowAllInstructionsPass = () => {
  if (showAllInstructionsCheckpointData.value) {
    emit("onPass", showAllInstructionsCheckpointData.value);
    // Close modal after emitting event - parent will handle API call and data refresh
    closeShowAllInstructionsDialog();
  }
};

const handleShowAllInstructionsFail = () => {
  if (showAllInstructionsCheckpointData.value) {
    emit("onFail", showAllInstructionsCheckpointData.value);
    // Close modal after emitting event - parent will handle API call and data refresh
    closeShowAllInstructionsDialog();
  }
};

const handleShowAllInstructionsNotApplicable = () => {
  if (showAllInstructionsCheckpointData.value) {
    emit("onNotApplicable", showAllInstructionsCheckpointData.value);
    // Close modal after emitting event - parent will handle API call and data refresh
    closeShowAllInstructionsDialog();
  }
};

const handleShowAllInstructionsObsolete = () => {
  if (showAllInstructionsCheckpointData.value) {
    emit("onObsolete", showAllInstructionsCheckpointData.value);
    // Close modal after emitting event - parent will handle API call and data refresh
    closeShowAllInstructionsDialog();
  }
};

const handleShowAllInstructionsClose = () => {
  if (showAllInstructionsCheckpointData.value) {
    emit("onClose", showAllInstructionsCheckpointData.value);
  }
  closeShowAllInstructionsDialog();
};
</script>

<style scoped>
.checklist-inspection-table-wrapper {
  background: #fff;
}

.checklist-inspection-table-wrapper ::v-deep .dx-datagrid-content .dx-datagrid-table .dx-row > td,
.checklist-inspection-table-wrapper
  ::v-deep
  .dx-datagrid-content
  .dx-datagrid-table
  .dx-row
  > tr
  > td {
  vertical-align: middle;
  padding: 7px 24px;
  overflow: hidden;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 0;
}

.checklist-inspection-table-wrapper
  ::v-deep
  .dx-datagrid-content
  .dx-datagrid-table
  .dx-header-row
  > td,
.checklist-inspection-table-wrapper
  ::v-deep
  .dx-datagrid-content
  .dx-datagrid-table
  .dx-header-row
  > tr
  > td {
  padding: 13px 24px !important;
}

.checklist-inspection-table-wrapper ::v-deep .dx-datagrid {
  background: #fff;
  overflow: auto;
  max-height: calc(100vh - 100px) !important;
}

.checklist-inspection-table-wrapper ::v-deep .dx-datagrid-headers {
  color: #667085;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  background-color: #f9fafb;
}

.checklist-inspection-table-wrapper ::v-deep .dx-datagrid-headers .dx-datagrid-table .dx-row > td,
.checklist-inspection-table-wrapper ::v-deep .dx-datagrid .dx-row-lines > td {
  border-bottom: 1px solid #eaecf0 !important;
}

.checklist-inspection-table-wrapper ::v-deep .dx-datagrid-headers {
  border-top: 1px solid #eaecf0;
}

.checklist-inspection-table-wrapper ::v-deep .dx-datagrid-rowsview {
  border-top: none;
  overflow-y: hidden !important;
}

.search-checklist {
  margin-top: -12px;
}

.top-section-class {
  margin-right: -9px;
}

::v-deep .no-record-found .wrapper {
  border: none !important;
}

/* Microlearning Dialog Styles */
.microlearning-iframe-container {
  width: 100%;
  height: 400px !important;
  margin: 0 auto;
}

.microlearning-iframe-container iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.microlearning-video-container {
  width: 100%;
  height: 400px !important;
  margin: 0 auto;
  border-radius: 8px;
  overflow: hidden;
  background: black;
}

.microlearning-video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: black;
  display: block;
}

.microlearning-card {
  background: white;
  border-radius: 8px;
}

.microlearning-title {
  background: #f9fafb;
  padding: 16px 24px;
  border-bottom: 1px solid #eaecf0;
}

.title-text {
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  color: #101828;
}

.close-btn-class {
  background: transparent !important;
}

.microlearning-content {
  padding: 24px;
}

.no-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 400px;
  color: #667085;
}

.no-content p {
  margin-top: 16px;
  font-size: 16px;
}

/* Show All Instructions Dialog Styles */
.show-all-instructions-card {
  background: white;
  border-radius: 8px;
}

.show-all-instructions-title {
  background: #f9fafb;
  padding: 16px 24px;
  border-bottom: 1px solid #eaecf0;
}

.show-all-instructions-content {
  padding: 24px;
  max-height: 80vh;
  overflow-y: auto;
}

/* Prevent truncation of passed status and badge level in checkpoint details pop-up */
.show-all-instructions-content ::v-deep .coach-checkpoint-card .card-header-actions,
.show-all-instructions-content ::v-deep .coach-checkpoint-card .card-header {
  flex-wrap: wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  min-width: 0;
}

.show-all-instructions-content ::v-deep .ex-checkpoint-band .v-chip,
.show-all-instructions-content ::v-deep .prop-status-label {
  white-space: normal;
  word-break: break-word;
  min-height: auto;
  height: auto;
  padding: 6px 12px;
}

.show-all-instructions-content ::v-deep .card-status,
.show-all-instructions-content ::v-deep .inspection-action-reset-pending .reset-pending-content,
.show-all-instructions-content ::v-deep .evaluation {
  min-width: 0;
  overflow: visible;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>
